import { loggedInUser } from 'hooks/use-logged-in-user';
import { useTaskService } from 'hooks/services/use-task-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskLookupType } from 'types';

interface TaskArchiveTimingsCache {
  taskArchiveTimings: ITaskLookupType[];
  isArchiveTimingsLoading: boolean;
  hasArchiveTimings: boolean;
}

export const useTaskArchiveTimingsCache = (): TaskArchiveTimingsCache => {
  const taskService = useTaskService();
  const { isLoggedIn } = loggedInUser.useController();

  const query = useQuery({
    queryKey: ['archiveTimings'],
    queryFn: () => taskService.getTaskArchiveTimings(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isArchiveTimingsLoading, data: taskArchiveTimings = [] } = query;

  return {
    isArchiveTimingsLoading,
    taskArchiveTimings,
    hasArchiveTimings: taskArchiveTimings.length > 0
  };
};
